export default __webpack_public_path__ + "static/media/splashImage-2.4382ddc7.jpg";